<template>
  <b-modal
    id="UnlinkClinic"
    ref="unlinkClinic"
    size="lg"
    centered
    no-close-on-backdrop
    hide-footer
    @close="close"
    @hidden="setDefaultModal"
  >
    <template #modal-title>
      <h5 class="ml-4 mt-2">ตัดการเชื่อมต่อคลินิก</h5>
    </template>
    <div class="modal-content-wrapper">
      <div class="unlink-container">
        <!-- Warning Alert -->
        <div class="warning-notice">
          <b-alert show variant="warning" class="mb-4">
            <i class="fas fa-exclamation-triangle mr-2"></i>
            <strong>คำเตือน:</strong>
            การตัดการเชื่อมต่อจะทำให้ผู้ป่วยไม่สามารถเข้าถึงข้อมูลได้
          </b-alert>
        </div>

        <!-- Confirmation Section -->
        <div class="confirmation-section mb-4">
          <div class="section-title">
            <i class="fas fa-unlink mr-2"></i> ยืนยันการตัดการเชื่อมต่อ
          </div>
          <div class="confirmation-content">
            <div class="confirmation-icon">
              <i class="fas fa-clinic-medical"></i>
              <div class="connection-line"></div>
              <i class="fas fa-user-slash"></i>
            </div>
            <div class="confirmation-message">
              ต้องการตัดการเชื่อมต่อคลินิกกับคนไข้นี้ใช่หรือไม่?
            </div>
            <div class="confirmation-note">
              ผู้ป่วยจะไม่สามารถเข้าถึงข้อมูลได้จนกว่าจะเชื่อมต่อใหม่
            </div>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons">
          <b-button variant="outline-secondary" class="mr-3" @click="close">
            <i class="fas fa-arrow-left mr-1"></i> ย้อนกลับ
          </b-button>
          <b-button variant="danger" @click="handleUnlinkCLinic(patientId)">
            <i class="fas fa-unlink mr-1"></i> ตัดการเชื่อมต่อ
          </b-button>
        </div>
      </div>
    </div>

    <Loading v-if="isLoading"></Loading>
    <Dialog ref="Dialog"></Dialog>
  </b-modal>
</template>

<script>
import Loading from "@/components/Loading";
import { mapActions } from "vuex";
import "@/theme/modal/CheckInList.scss";
import Dialog from "@/components/modal/Dialog";
import { eventBus } from "../../../main";

export default {
  name: "UnlinkClinic",
  props: {
    patientId: {
      type: Number,
    },
  },
  components: {
    Loading,
    Dialog,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {},
  methods: {
    ...mapActions({
      updateUnlinkClinic: "moduleTreatment/updateUnlinkClinic",
      fetchPatientConnectClinicStatus:
        "moduleTreatment/fetchPatientConnectClinicStatus",
    }),

    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    handleUnlinkCLinic(patientId) {
      this.isLoading = true;
      this.updateUnlinkClinic({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
        dc_patient_id: patientId,
      })
        .then(res => {
          if (res.status == 200) {
            this.checkConnectClinic(patientId).then(() => {
              eventBus.$emit("updateConnectClinic");
              this.showDialogToast("success", `ตัดการเชื่อมต่อคลินิกสำเร็จ`);
            });
          }
        })
        .catch(error => {
          this.showDialogToast("danger", `ตัดการเชื่อมต่อคลินิกไม่สำเร็จ`);
        })
        .finally(() => {
          this.close();
        });
    },

    async checkConnectClinic(patientId) {
      if (!patientId) return;
      if (patientId) {
        const res = await this.fetchPatientConnectClinicStatus({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          patientId,
        });
        this.isConnected = res.data.is_connected;
      }
    },

    show() {
      this.$bvModal.show("UnlinkClinic");
    },
    close() {
      this.$bvModal.hide("UnlinkClinic");
      this.setDefaultModal();
    },
    setDefaultModal() {
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.modal-content-wrapper {
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.unlink-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1rem;
}

.warning-notice {
  width: 100%;
  max-width: 500px;
  margin-bottom: 8px;
}

.warning-notice .alert {
  border-left: 4px solid #f0ad4e;
}

.confirmation-section {
  width: 100%;
  max-width: 500px;
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 8px;
  background-color: #f9f1f2;
  border-left: 4px solid #dc3545;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.confirmation-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}

.confirmation-icon {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-size: 24px;
}

.confirmation-icon i:first-child {
  color: #4a5568;
}

.confirmation-icon i:last-child {
  color: #dc3545;
}

.connection-line {
  width: 80px;
  height: 2px;
  background-color: #dc3545;
  position: relative;
  margin: 0 15px;
}

.connection-line:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: repeating-linear-gradient(
    90deg,
    #dc3545,
    #dc3545 5px,
    transparent 5px,
    transparent 10px
  );
}

.confirmation-message {
  font-size: 18px;
  font-weight: 500;
  color: #2d3748;
  text-align: center;
  margin-bottom: 10px;
}

.confirmation-note {
  font-size: 14px;
  color: #718096;
  text-align: center;
  margin-bottom: 10px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}

@media (min-width: 1400px) {
  .col-ul-2 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}
</style>